import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import {
  WorkOrderProgress,
  PerformanceMetrics,
} from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-work-orders-progress",
  templateUrl: "./work-orders-progress.component.html",
  styleUrl: "./work-orders-progress.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkOrdersProgressComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly orders = computed<WorkOrderProgress[]>(
    () =>
      this.stateService.lastData()?.workOrders?.slice(0, DISPLAY_LIMIT) ?? [],
  );

  readonly metrics = computed<PerformanceMetrics | null>(
    () => this.stateService.lastData()?.performanceMetrics ?? null,
  );

  readonly animationTrigger = computed(() => this.orders());
}
